module.exports = __webpack_public_path__ + "img/playstore-icon.05a9ea84.svg";